import { IMarketYoyGrowthEditEntry, IMarketYoyGrowthExpectation } from '../model/types'

/**
 * Resolves a pending edit entry into a full record: merges the growth-field
 * patch onto the matching fetched `record`, or onto `entry.base` when the
 * entry is a phantom edit with no backing fetched record.
 */
export const resolveMarketYoyGrowthEditRecord = (
  entry: IMarketYoyGrowthEditEntry,
  record: IMarketYoyGrowthExpectation | undefined
): IMarketYoyGrowthExpectation => {
  const { base, ...patch } = entry
  const source = record ?? base

  if (!source) {
    throw new Error('Market YoY growth edit entry has no backing record and no synthesized base')
  }

  return { ...source, ...patch }
}
